import React from 'react';

/**
 * DeliveryTruck SVG Component
 * 
 * @param {string|number} width - Width of the SVG (default: 180)
 * @param {string|number} height - Height of the SVG (default: 104)
 * @param {string} className - Additional CSS class names
 * @param {object} style - Additional inline styles
 * @param {string} fill - Fill color for the illustration (optional)
 * @param {object} ...props - Additional props passed to the SVG element
 */
const DeliveryTruckSvg = ({ 
  width = 180, 
  height = 104, 
  className = '',
  style = {},
  fill,
  ...props 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 180 104" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      {/* Road/Ground */}
      <path 
        d="M0 101.122H180C180 97.0476 176.698 93.7452 172.624 93.7452H7.37627C3.3024 93.7452 0 97.0476 0 101.122Z" 
        fill="#B1D3DB"
      />

      {/* Side stripe */}
      <path 
        d="M9.07933 79.4824H3.97693V71.9786C3.97693 69.6724 5.84669 67.8027 8.15287 67.8027H9.07898V79.4824H9.07933Z" 
        fill="#CC0000"
      />

      {/* Truck back section */}
      <path 
        d="M101.083 11.2972H129.087L147.017 36.9886L167.012 41.8058C167.012 41.8058 170.682 53.8487 170.682 83.7834L99.3954 81.6329L101.083 11.2972Z" 
        fill={fill || "#FFBF40"}
      />

      {/* Windshield */}
      <path 
        d="M143.547 37.0817H104.338V14.1965H127.574L143.547 37.0817Z" 
        fill="#8C8C8C"
      />

      {/* Windshield content with masks */}
      <mask id="mask0_5765_40542" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="104" y="14" width="40" height="24">
        <path d="M143.547 37.0817H104.338V14.1965H127.574L143.547 37.0817Z" fill="white"/>
      </mask>

      <g mask="url(#mask0_5765_40542)">
        <path 
          d="M115.914 27.8142L115.471 27.5936C115.471 27.5936 115.51 26.4159 114.988 25.9805C114.465 25.5451 113.554 24.4496 114.045 23.107C114.436 22.0331 115.206 20.596 117.818 20.6541C120.43 20.7122 121.265 22.2651 122.067 23.252C122.869 24.239 121.68 25.5596 120.403 25.1097C119.126 24.6599 118.397 25.2115 118.397 25.2115L115.914 27.8142Z" 
          fill="#0D0D0D"
        />
      </g>

      <mask id="mask1_5765_40542" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="104" y="14" width="40" height="24">
        <path d="M143.547 37.0817H104.338V14.1965H127.574L143.547 37.0817Z" fill="white"/>
      </mask>

      <g mask="url(#mask1_5765_40542)">
        <path 
          d="M130.888 38.822C130.843 38.822 130.798 38.8179 130.753 38.8093C130.359 38.7355 130.101 38.3568 130.174 37.9633L131.318 31.8743C131.392 31.4808 131.772 31.2217 132.164 31.2956C132.558 31.3695 132.817 31.7482 132.743 32.1416L131.599 38.2306C131.534 38.5791 131.229 38.822 130.888 38.822Z" 
          fill="#0D0D0D"
        />
      </g>

      <mask id="mask2_5765_40542" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="104" y="14" width="40" height="24">
        <path d="M143.547 37.0817H104.338V14.1965H127.574L143.547 37.0817Z" fill="white"/>
      </mask>

      <g mask="url(#mask2_5765_40542)">
        <path 
          d="M106.32 24.5251H104.338V37.0817H110.506V28.7113C110.506 26.3996 108.632 24.5251 106.32 24.5251Z" 
          fill="#0D0D0D"
        />
      </g>

      {/* Additional windshield details */}
      <mask id="mask3_5765_40542" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="104" y="14" width="40" height="24">
        <path d="M143.547 37.0817H104.338V14.1965H127.574L143.547 37.0817Z" fill="white"/>
      </mask>

      <g mask="url(#mask3_5765_40542)">
        <path 
          d="M115.904 30.3659C115.904 30.3659 120.875 35.0769 130.161 35.2872V37.0817L118.191 37.9824L113.463 33.8085L115.904 30.3659Z" 
          fill="#0358A3"
        />
      </g>

      <mask id="mask4_5765_40542" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="104" y="14" width="40" height="24">
        <path d="M143.547 37.0817H104.338V14.1965H127.574L143.547 37.0817Z" fill="white"/>
      </mask>

      <g mask="url(#mask4_5765_40542)">
        <path 
          d="M129.067 35.5261C129.067 35.5261 131.111 33.4041 131.458 33.8773C131.806 34.3505 131.189 35.0526 131.189 35.0526C131.189 35.0526 132.422 34.4172 132.565 35.2869C132.709 36.1567 133.411 38.0062 129.354 37.7051L128.121 37.0818L129.067 35.5261Z" 
          fill="#EFA484"
        />
      </g>

      <mask id="mask5_5765_40542" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="104" y="14" width="40" height="24">
        <path d="M143.547 37.0817H104.338V14.1965H127.574L143.547 37.0817Z" fill="white"/>
      </mask>

      <g mask="url(#mask5_5765_40542)">
        <path 
          d="M114.406 29.8776L115.859 26.7618C115.859 26.7618 114.758 25.5694 115.369 24.9766C115.981 24.3838 116.661 25.6391 116.661 25.6391C116.661 25.6391 116.563 24.0484 118.188 24.1058C119.813 24.1632 119.127 25.0986 121.077 25.0797C121.077 25.0797 121.363 27.7175 120.58 28.8264C119.796 29.935 117.349 29.1322 117.349 29.1322L115.763 32.4391L114.406 29.8776Z" 
          fill="#EFA484"
        />
      </g>

      <mask id="mask6_5765_40542" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="104" y="14" width="40" height="24">
        <path d="M143.547 37.0817H104.338V14.1965H127.574L143.547 37.0817Z" fill="white"/>
      </mask>

      <g mask="url(#mask6_5765_40542)">
        <path 
          d="M114.627 29.467C114.627 29.467 110.506 31.2495 110.506 37.0821L121.899 40.6972L129.354 37.7055L129.067 35.5264C129.067 35.5264 123.335 35.5491 120.238 34.2299C117.141 32.911 114.627 29.467 114.627 29.467Z" 
          fill="#0081F2"
        />
      </g>

      <mask id="mask7_5765_40542" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="104" y="14" width="40" height="24">
        <path d="M143.547 37.0817H104.338V14.1965H127.574L143.547 37.0817Z" fill="white"/>
      </mask>

      <g mask="url(#mask7_5765_40542)">
        <path d="M114.906 28.8048L114.406 29.8776L115.763 32.4391L116.953 29.958L114.906 28.8048Z" fill="#0081F2"/>
      </g>

      {/* Main truck body */}
      <path 
        d="M101.082 79.4823H7.32056V7.27044C7.32056 3.25532 10.5755 0 14.591 0H89.785C96.0242 0 101.082 5.05807 101.082 11.2972V79.4823Z" 
        fill="#FFA525"
      />

      {/* Truck decorative elements */}
      <path 
        d="M140.632 62.4504C128.85 62.4504 119.299 72.0016 119.299 83.7834H161.965C161.965 72.0016 152.414 62.4504 140.632 62.4504Z" 
        fill="#FFBF40"
      />

      <path 
        d="M138.482 83.7833H3.97741C2.78979 83.7833 1.8269 82.8204 1.8269 81.6328C1.8269 80.4451 2.78979 79.4822 3.97741 79.4822H138.482C139.67 79.4822 140.633 80.4451 140.633 81.6328C140.633 82.8204 139.67 83.7833 138.482 83.7833Z" 
        fill="#FFBF40"
      />

      <path 
        d="M170.778 83.7832H157.989V72.0462H170.414C171.491 72.0462 172.364 72.919 172.364 73.996V82.1966C172.364 83.0729 171.654 83.7832 170.778 83.7832Z" 
        fill="#FFBF40"
      />

      <path 
        d="M140.633 66.4264C131.047 66.4264 123.276 74.1971 123.276 83.7834H157.99C157.99 74.1975 150.219 66.4264 140.633 66.4264Z" 
        fill="#0D0D0D"
      />

      {/* Side panel details */}
      <path 
        d="M168.458 49.7299C168.962 53.0783 169.493 57.5598 169.896 63.3002H168.046C166.301 63.3 164.886 61.8853 164.886 60.1401V49.7299H168.458Z" 
        fill="white" 
        stroke="#FFA525" 
        strokeWidth="0.25"
      />

      <path 
        d="M167.707 44.7303H166.842C165.693 44.7303 164.761 45.6622 164.761 46.8114V49.6045H168.565C168.256 47.5647 167.957 45.9488 167.707 44.7303Z" 
        fill="#CC0000"
      />

      <path 
        d="M144.68 41.8053H139.294C137.41 41.8053 135.882 40.2778 135.882 38.3933C135.882 36.5088 137.41 34.9813 139.294 34.9813H143.734C145.452 34.9813 146.845 36.3741 146.845 38.0923V39.6407C146.845 40.8363 145.876 41.8053 144.68 41.8053Z" 
        fill="#FFA525"
      />

      <path 
        d="M114.884 43.3349H109.818C109.396 43.3349 109.053 42.9927 109.053 42.5703C109.053 42.148 109.396 41.8057 109.818 41.8057H114.884C115.306 41.8057 115.648 42.148 115.648 42.5703C115.648 42.9923 115.306 43.3349 114.884 43.3349Z" 
        fill="#FFA525"
      />

      {/* Structural lines */}
      <path 
        d="M104.338 37.0816V79.4822" 
        stroke="#FFA525" 
        strokeWidth="0.9724" 
        strokeMiterlimit="10" 
        strokeLinecap="round"
      />

      <path 
        d="M143.547 37.0816V62.6695" 
        stroke="#FFA525" 
        strokeWidth="0.9724" 
        strokeMiterlimit="10" 
        strokeLinecap="round"
      />

      {/* Back wheel */}
      <path 
        d="M140.633 86.842C142.322 86.842 143.691 85.4727 143.691 83.7836C143.691 82.0944 142.322 80.7251 140.633 80.7251C138.944 80.7251 137.574 82.0944 137.574 83.7836C137.574 85.4727 138.944 86.842 140.633 86.842Z" 
        stroke="white" 
        strokeWidth="0.4218" 
        strokeMiterlimit="10"
      />

      <path 
        d="M143.898 97.6091C151.542 95.8041 156.276 88.1441 154.471 80.5001C152.666 72.856 145.006 68.1225 137.362 69.9275C129.717 71.7324 124.984 79.3924 126.789 87.0365C128.594 94.6806 136.254 99.4141 143.898 97.6091Z" 
        fill="#666666"
      />

      <path 
        d="M143.283 95.0046C149.488 93.5393 153.331 87.3208 151.866 81.1151C150.401 74.9095 144.182 71.0668 137.976 72.5321C131.771 73.9974 127.928 80.2159 129.393 86.4215C130.859 92.6272 137.077 96.4699 143.283 95.0046Z" 
        fill="#8C8C8C"
      />

      <path 
        d="M141.978 89.4793C145.132 88.7346 147.085 85.5738 146.341 82.4197C145.596 79.2655 142.435 77.3124 139.281 78.0571C136.127 78.8019 134.174 81.9626 134.918 85.1168C135.663 88.2709 138.824 90.2241 141.978 89.4793Z" 
        fill="#995A00"
      />

      <path 
        d="M140.633 86.842C142.322 86.842 143.691 85.4727 143.691 83.7836C143.691 82.0944 142.322 80.7251 140.633 80.7251C138.944 80.7251 137.574 82.0944 137.574 83.7836C137.574 85.4727 138.944 86.842 140.633 86.842Z" 
        fill="#8C8C8C"
      />

      {/* Front wheel */}
      <path 
        d="M42.7388 86.8419C44.4279 86.8419 45.7972 85.4726 45.7972 83.7835C45.7972 82.0944 44.4279 80.7251 42.7388 80.7251C41.0497 80.7251 39.6804 82.0944 39.6804 83.7835C39.6804 85.4726 41.0497 86.8419 42.7388 86.8419Z" 
        stroke="white" 
        strokeWidth="0.4218" 
        strokeMiterlimit="10"
      />

      <path 
        d="M52.7938 93.8392C58.3478 88.2852 58.3478 79.2805 52.7938 73.7265C47.2398 68.1725 38.2351 68.1725 32.6811 73.7265C27.1271 79.2805 27.1271 88.2852 32.6811 93.8392C38.2351 99.3932 47.2398 99.3932 52.7938 93.8392Z" 
        fill="#666666"
      />

      <path 
        d="M50.9008 91.9468C55.4096 87.438 55.4096 80.1277 50.9008 75.6189C46.392 71.1101 39.0817 71.1101 34.5729 75.6189C30.0641 80.1277 30.0641 87.438 34.5729 91.9468C39.0817 96.4556 46.392 96.4556 50.9008 91.9468Z" 
        fill="#8C8C8C"
      />

      <path 
        d="M46.8868 87.9324C49.1785 85.6406 49.1785 81.925 46.8868 79.6333C44.5951 77.3416 40.8795 77.3416 38.5878 79.6333C36.296 81.925 36.296 85.6406 38.5878 87.9324C40.8795 90.2241 44.5951 90.2241 46.8868 87.9324Z" 
        fill="#995A00"
      />

      <path 
        d="M42.7388 86.8419C44.4279 86.8419 45.7972 85.4726 45.7972 83.7835C45.7972 82.0944 44.4279 80.7251 42.7388 80.7251C41.0497 80.7251 39.6804 82.0944 39.6804 83.7835C39.6804 85.4726 41.0497 86.8419 42.7388 86.8419Z" 
        fill="#8C8C8C"
      />

      <path 
        d="M42.7387 66.4264C33.1529 66.4264 25.3821 74.1971 25.3821 83.7834H60.0958C60.0954 74.1975 52.3246 66.4264 42.7387 66.4264Z" 
        fill="#FFBF40"
      />

      {/* Windshield frame */}
      <path 
        d="M143.547 37.0817H104.338V14.1965H127.574L143.547 37.0817Z" 
        stroke="#666666" 
        strokeWidth="0.9724" 
        strokeMiterlimit="10" 
        strokeLinecap="round"
      />

      {/* Cargo area */}
      <path 
        d="M33.4967 51.3105H73.6379C76.3162 51.3105 78.4873 49.1394 78.4873 46.461V21.0821C78.4873 18.4037 76.3162 16.2326 73.6379 16.2326H33.4967C30.8183 16.2326 28.6472 18.4037 28.6472 21.0821V46.4614C28.6469 49.1394 30.8183 51.3105 33.4967 51.3105Z" 
        fill="white"
      />

      <path 
        d="M71.7359 48.1797H45.2604C44.3377 48.1797 43.5896 47.4316 43.5896 46.5089V21.955C43.5896 21.0323 44.3377 20.2842 45.2604 20.2842H71.7359C72.6586 20.2842 73.4067 21.0323 73.4067 21.955V46.5093C73.4067 47.432 72.6586 48.1797 71.7359 48.1797Z" 
        fill="#995A00"
      />

      <path 
        d="M56.5415 21.9999H48.458C48.2049 21.9999 47.9998 21.5523 47.9998 20.9999C47.9998 20.4475 48.2049 19.9999 48.458 19.9999H56.5415C56.7946 19.9999 56.9998 20.4475 56.9998 20.9999C56.9999 21.5523 56.7946 21.9999 56.5415 21.9999Z" 
        fill="white"
      />

      <path 
        d="M71.736 48.1798H63.5941V20.2527H71.736C72.6587 20.2527 73.4068 21.0008 73.4068 21.9234V46.509C73.4068 47.432 72.6587 48.1798 71.736 48.1798Z" 
        fill="#BF7000"
      />

      <path 
        d="M70.0014 21.3745H65.4964C65.2221 21.3745 64.9998 21.0668 64.9998 20.6872C64.9998 20.3076 65.2221 19.9999 65.4964 19.9999H70.0014C70.2757 19.9999 70.498 20.3076 70.498 20.6872C70.4982 21.0666 70.2757 21.3745 70.0014 21.3745Z" 
        fill="white"
      />

      <path 
        d="M159.407 73.6463C155.8 66.9789 148.745 62.4504 140.632 62.4504C131.959 62.4504 124.494 67.6263 121.159 75.0583" 
        stroke="#FFA525" 
        strokeWidth="0.9724" 
        strokeMiterlimit="10" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default DeliveryTruckSvg;